import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Mode } from '../../containers/payment-details-not-consistent-dialog-entry/payment-details-not-consistent-dialog-entry.component';

@Component({
standalone: false,
  selector: 'app-payment-details-not-consistent-dialog',
  styleUrls: ['./payment-details-not-consistent-dialog.component.scss'],
  templateUrl: './payment-details-not-consistent-dialog.component.html',
})
export class PaymentDetailsNotConsistentDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public mode: Mode) {}
}
